import styled from 'styled-components';
import { layout, media, colorUtils } from '@prisjakt/ui-base';
import { Modal } from '../../../styles';
import { Floater } from '@prisjakt/ui/floater';
import { zindex } from 'src/ui/zindex';

export const FilterPanelWrapper = styled.div`
  background: ${p => p.theme.bg.primary};
  padding: ${layout.measurements.spacing100};
  border-radius: 8px;
  width: 100%;
  margin-bottom: ${layout.measurements.spacing050};
  border: 1px solid ${p => p.theme.lines.primary};
  box-shadow: ${p =>
    `0px 2px 8px 0px ${colorUtils.setRgbaAlpha(p.theme.colors.base800, 0.24)}`};
`;

export const FiltersDropDown = styled(Floater)`
  z-index: ${zindex.tooltip};
  transform: translate(1rem, 4.5em);

  ${media.smallOnly`
  z-index: ${zindex.menu.header};
  transform: translateY(${layout.measurements.spacing100});

    &.Floater--positioning-absolute {
      position:fixed;
      bottom: 0;
      top: auto;
      width: 100%;
    }
  `}
`;

export const FilterBlocker = styled.div`
  z-index: ${zindex.tooltip};
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  ${media.smallOnly`
    z-index: ${zindex.menu.header};
    background-color: ${p => p.theme.bg.overlay};
  `}
`;

export const FilterPanel = styled.div`
  display: grid;
  gap: ${layout.measurements.spacing050};
  width: 100%;

  grid-template-rows: auto;
  grid-auto-flow: row;
  grid-template-columns: 1fr;

  ${media.mediumDown`
    grid-template-rows: auto;
    grid-auto-flow: row;
    grid-template-columns: 1fr;
  `};
`;

export const FilterRow = styled.div`
  margin-bottom: ${layout.measurements.spacing150};

  &:last-child {
    margin-bottom: 0;
  }

  > span {
    display: block;
    margin-bottom: ${layout.measurements.spacing050};
  }
`;

export const FilterOptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0;
`;

export const CheckboxClickarea = styled.div``;

export const StyledModal = styled(Modal)`
  && {
    max-height: 90vh;
    overflow-y: scroll;
  }
`;

export const Header = styled.div`
  margin-bottom: ${layout.measurements.spacing050};

  &:not(:first-child) {
    margin-top: ${layout.measurements.spacing150};
  }
`;

export const SortingText = styled.div`
  ${media.smallOnly`
    padding: ${layout.measurements.spacing100} 0;
  `}
`;

export const FilterMobileHeader = styled.div`
  display: none;
  position: relative;

  ${media.smallOnly`
    display: block;
  `};
`;

export const CloseButton = styled.div`
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
`;
